module.exports = __webpack_public_path__ + "static/media/video_cam.89117dc5.png";